<template>
  <div class="wrapper">
    <header class="bg">
      <!-- <router-link to="/" class="back">← 返回首页</router-link> -->
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/gc-logo.png" /></div>
      <p>葡萄城</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = 'https://uedcdn.zto.com/static/gc/'
export default {
  name: 'index',
  data () {
    return {
      fileList: [{
        label: '10.1.0',
        linkList: [
          ur + '10.1.0/gc.spread.sheets.css',
          ur + '10.1.0/gc.spread.sheets.min.css',
          ur + '10.1.0/gc.spread.sheets.all.js',
          ur + '10.1.0/gc.spread.sheets.all.min.js',
          ur + '10.1.0/gc.spread.sheets.resources.zh.min.js'
        ]
      }]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/ListGrapeCity.vue